<template>
	<article>
		<div class="flex items-center gap-4 group">
			<div
				class="flex items-center justify-center flex-none bg-gray-100 rounded-md size-14"
			>
				<img :src="iconUrl" alt="" class="size-6" />
			</div>
			<div class="flex flex-col py-1">
				<span class="font-semibold">
					{{ splitHdnValue(doc.docSoort)[1] }}
				</span>
				<span v-if="doc.docSoortOmschrijving" class="text-sm text-gray-500">
					{{ doc.docSoortOmschrijving }}
				</span>
				<span class="text-sm text-gray-500">
					Ontvangen: {{ formatDate(doc.creationDate) }}
				</span>
			</div>

			<AppButton
				variant="ghost"
				icon="download"
				class="flex-none ml-auto mr-2"
				aria-label="Document downloaden"
				@click="onDownloadClick()"
			/>
		</div>
	</article>
</template>

<script setup lang="ts">
import type { ReadOfferDocument } from "@/generatedApi";
import { getFileIcon, getFileType } from "@/helpers/fileHelpers";
import { splitHdnValue } from "@/helpers/hdnHelpers";
import { saveAs } from "file-saver";
import { computed } from "vue";

interface Props {
	doc: ReadOfferDocument;
	downloadUrl: string;
}
const props = defineProps<Props>();

const iconUrl = computed(() => getFileIcon(getFileType(props.doc.contentType)));

function onDownloadClick() {
	saveAs(props.downloadUrl, props.doc.filename);
}

function formatDate(dateString: string) {
	const date = new Date(dateString);
	return date.toLocaleString("nl");
}
</script>
